import { z } from 'zod';

export const machineSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  isActive: z.boolean(),
  notes: z.string().optional(),
  isSampelRoaster: z.boolean().optional(),
});

export type MachineFormData = z.infer<typeof machineSchema>;

export interface Machine {
  id: string;
  name: string;
  isActive: boolean;
  notes?: string;
  isSampelRoaster?: boolean;
  minimumInputKg?: number;
  maximumInputKg?: number;
  parentMachineId?: string;
  value?: string;
  createdAt?: string;
  updatedAt?: string;
}
